export const isTranslationMissing = (entity) => {
    if(entity == null || typeof entity == "string") {
        return false;
    }

   for(let key in entity) {
     if(key == "de" || key == "en" || key == "fr") {
       if(entity[key] == null || entity[key] == "") {
         return true;
       }
     }
     if(isTranslationMissing(entity[key])) {
       return true;
     }
   }
   return false;
}

export const findTranslation = (entity, key) => {
    if(typeof entity[key] == "string") {
        return entity[key];
    } else {
        return entity[key]["de"];
    }
}
